import Dashboard from "./dashboard.vue";

const dashboardRoutes = [
  {
    path: "",
    component: Dashboard,
    name: "dashboard.index",
    // meta: {
    //   auth: {
    //     redirect: { name: "auth.login" }
    //   }
    // }
  }
];

export default dashboardRoutes;
